/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export class ClipboardUtils {
  public static copyTextToClipboard(text: string): void {
    navigator.clipboard?.writeText(text);
  }

  public static async copyImageToClipboard(imageURL: string): Promise<void> {
    // get the image metadata to determine size
    const imageMetadataUrl = `${imageURL}?fm=json`;
    const imageMetadata = await fetch(imageMetadataUrl).then((res) => res.json());
    const { PixelWidth, PixelHeight } = imageMetadata;

    // create a image element to load the image
    let image = new Image(PixelWidth, PixelHeight);
    image.src = imageURL;
    // create a canvas to draw the image on (image format must be png hence this step is required)
    image.crossOrigin = "Anonymous";
    let canvas = document.createElement("canvas");
    canvas.width = PixelWidth;
    canvas.height = PixelHeight;
    let ctx = canvas.getContext("2d");

    // turn the canvas into a blob in png format
    const getBlob = async (): Promise<Blob> => {
      await image.decode(); // wait for the image to be decoded
      ctx?.drawImage(image, 0, 0, canvas.width, canvas.height); // draw the image on the canvas
      const pngUrl = canvas.toDataURL("image/png"); // turn the canvas into a data url
      const res = await fetch(pngUrl);
      const blob = await res.blob(); // turn the data url into a blob (has to be done like this in order to work in Safari)
      return blob;
    };
    navigator.clipboard?.write([new ClipboardItem({ "image/png": getBlob() })]); // copy the blob to the clipboard
  }
}
